module.exports = __webpack_public_path__ + "static/media/IconUser.7acf5040.svg";